// what one person can show another. everyone picks for themselves, per person and per kind of thing,
// and the other side only ever reads it. shared by the server (which enforces it) and the app (which draws the switches)

export interface ShareKind {
  id: string;
  label: string;
  detail: string;
  // the feature the sharer needs to have this kind of thing at all
  feature: string;
}

export const SHARE_KINDS: ShareKind[] = [
  { id: "notes", label: "Notes", detail: "your sticky notes", feature: "notes" },
  { id: "pings", label: "Pings", detail: "reminders, alarms and timers", feature: "time" },
  { id: "calendar", label: "Calendar events", detail: "your own events on the month", feature: "time" },
  { id: "tasks", label: "Tasks", detail: "plane and chix bot", feature: "tasks" },
  { id: "comms", label: "Commissions", detail: "clients, prices, status, linked tasks and money stats", feature: "studio" },
  { id: "budget", label: "Budget", detail: "bills, costs, debts and goals", feature: "budget" },
  { id: "routines", label: "Routines", detail: "what you keep up and your streaks", feature: "routines" },
  { id: "goals", label: "Goals", detail: "your goals, how far along they are and the ones you've done", feature: "goals" },
  { id: "places", label: "Places and routes", detail: "spots and routes you saved on the map", feature: "maps" }
];

// a step up from reading one kind: the other person can also put things in. only on while the kind itself is shared
export interface ShareExtra {
  id: string;
  of: string;
  label: string;
  detail: string;
}

export const SHARE_EXTRAS: ShareExtra[] = [
  { id: "budget-add", of: "budget", label: "Can add to it", detail: "bills, costs, money in and payments, with their name on them. they can change only what they added" }
];

// viewer id to the kinds shared with them
export type ShareMap = Record<string, string[]>;

export interface SharePerson {
  id: string;
  name: string;
}

export interface ShareBoard {
  // the kinds this user has and so can share
  kinds: string[];
  // everyone else in chix
  people: SharePerson[];
  // what this user shares with each of them
  mine: ShareMap;
  // who shares what with this user
  withMe: Array<SharePerson & { kinds: string[] }>;
}

// live note to a viewer that something shared with them changed
export interface SharedChange {
  kind: string;
  from: string;
}

export function cleanKinds(raw: unknown): string[] {
  const given = Array.isArray(raw) ? raw.map(String) : [];
  const kinds = SHARE_KINDS.map((kind) => kind.id).filter((id) => given.includes(id));
  const extras = SHARE_EXTRAS.filter((extra) => given.includes(extra.id) && kinds.includes(extra.of)).map((extra) => extra.id);
  return [...kinds, ...extras];
}
